import { render } from "./Cupboard.vue?vue&type=template&id=481eefae"
import script from "./Cupboard.vue?vue&type=script&lang=js"
export * from "./Cupboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/lifetime/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__